import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LeftSidePanel from '@/components/UI/LeftSidePanel';
import { Button } from '@/components/UI/Button';

const AccountSuspendedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="auth-bg flex min-h-dvh relative overflow-hidden">
      <LeftSidePanel />

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="card-surface px-10 py-10 text-center w-full max-w-md">
          <div className="w-16 h-16 rounded-full bg-danger/15 flex items-center justify-center mx-auto mb-6">
            <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8 text-danger-text" stroke="currentColor" strokeWidth={2}>
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" strokeLinecap="round" />
            </svg>
          </div>

          <h1 className="text-h3 text-ui-text mb-3">
            {t('suspension.accountTitle', 'Account Suspended')}
          </h1>

          <p className="text-sm text-ui-text2 mb-2">
            {t('suspension.accountMessage', 'Your account has been suspended by the platform administrator.')}
          </p>
          <p className="text-sm text-ui-text3 mb-8">
            {t('suspension.contactSupport', 'Please contact support if you believe this is an error.')}
          </p>

          <Button size="lg" className="w-full"
            onClick={() => navigate('/login')}>
            {t('auth.backToLogin', 'Back to Login')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountSuspendedPage;
